module.exports = __webpack_public_path__ + "img/v1-2.772b3b27.png";